import typeahead from '@app/adapters/typeahead'
import './changelog'
import './color-picker'
import './pulse-files-upload'
import setupAdminUsers from './setup-admin-users'
import setupAutoComplete from './setup-auto-complete'
import setupBackgroundPolling from './setup-background-polling'
import setupBootstrap from './setup-bootstrap'
import setupFiscalYears from './setup-fiscal-years-form'
import setupMluRetainedEarningsAccount from './mlu-retained-earnings-account'
import setupProgressChecker from './setup-progress-checker'
import setupSanitization from './setup-sanitization'
import './track-event'

setupAdminUsers()
setupAutoComplete({ onDomLoad: window.onDomLoad, typeahead })
setupBackgroundPolling()
setupBootstrap()
setupFiscalYears()
setupMluRetainedEarningsAccount()
setupProgressChecker()
setupSanitization()
